(function () {
  if (window.__mtInit) return;
  window.__mtInit = true;

  var reducido = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var observador = 'IntersectionObserver' in window ? new IntersectionObserver(function (entradas) {
    entradas.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('mt-visible'); observador.unobserve(e.target); }
    });
  }, { threshold: 0.15 }) : null;

  function initReveals(raiz) {
    raiz.querySelectorAll('.mt-reveal, [data-mt-observa]').forEach(function (el) {
      if (el.dataset.mtObs) return;
      el.dataset.mtObs = '1';
      if (!observador || reducido) el.classList.add('mt-visible'); else observador.observe(el);
    });
  }

  function initHero(raiz) {
    raiz.querySelectorAll('.mt-hero').forEach(function (h) {
      if (h.dataset.mtInit) return;
      h.dataset.mtInit = '1';
      requestAnimationFrame(function () { requestAnimationFrame(function () { h.classList.add('mt-listo'); }); });
    });
  }

  function initHotspots(raiz) {
    raiz.querySelectorAll('[data-mt-hotspots]').forEach(function (s) {
      if (s.dataset.mtInit) return;
      s.dataset.mtInit = '1';
      var puntos = s.querySelectorAll('.mt-hs-punto');
      var items = s.querySelectorAll('.mt-hs-item');
      function activa(i) {
        puntos.forEach(function (p, j) { p.classList.toggle('mt-activo', i === j); });
        items.forEach(function (it, j) { it.classList.toggle('mt-activo', i === j); });
      }
      puntos.forEach(function (p, i) { p.addEventListener('click', function () { activa(i); }); p.addEventListener('mouseenter', function () { activa(i); }); });
      items.forEach(function (it, i) { it.addEventListener('click', function () { activa(i); }); it.addEventListener('mouseenter', function () { activa(i); }); });
      activa(0);
    });
  }

  function initFaq(raiz) {
    raiz.querySelectorAll('.mt-faq-item').forEach(function (it) {
      if (it.dataset.mtInit) return;
      it.dataset.mtInit = '1';
      var b = it.querySelector('.mt-faq-pregunta');
      b.addEventListener('click', function () {
        var abierto = it.classList.toggle('mt-abierto');
        b.setAttribute('aria-expanded', abierto ? 'true' : 'false');
      });
    });
  }

  function initMagnetico(raiz) {
    if (reducido || !window.matchMedia('(hover: hover)').matches) return;
    raiz.querySelectorAll('[data-mt-magnetico]').forEach(function (b) {
      if (b.dataset.mtInit) return;
      b.dataset.mtInit = '1';
      b.addEventListener('mousemove', function (e) {
        var r = b.getBoundingClientRect();
        var x = (e.clientX - r.left - r.width / 2) / r.width;
        var y = (e.clientY - r.top - r.height / 2) / r.height;
        b.style.transform = 'translate(' + (x * 8).toFixed(1) + 'px,' + (y * 6).toFixed(1) + 'px)';
      });
      b.addEventListener('mouseleave', function () { b.style.transform = ''; });
    });
  }

  function initGaleria(raiz) {
    raiz.querySelectorAll('[data-mt-galeria]').forEach(function (g) {
      if (g.dataset.mtInit) return;
      g.dataset.mtInit = '1';
      var principal = g.querySelector('.mt-galeria-principal img');
      g.querySelectorAll('.mt-galeria-mini').forEach(function (m) {
        m.addEventListener('click', function () {
          g.querySelectorAll('.mt-galeria-mini').forEach(function (o) { o.classList.remove('mt-activo'); });
          m.classList.add('mt-activo');
          principal.style.opacity = '0';
          setTimeout(function () { principal.src = m.dataset.src; principal.alt = m.dataset.alt || ''; principal.style.opacity = '1'; }, 180);
        });
      });
    });
  }

  function initVariantes(raiz) {
    raiz.querySelectorAll('[data-mt-producto]').forEach(function (form) {
      if (form.dataset.mtInit) return;
      form.dataset.mtInit = '1';
      var json = form.querySelector('[data-mt-variantes]');
      if (!json) return;
      var variantes = JSON.parse(json.textContent);
      var input = form.querySelector('input[name="id"]');
      var boton = form.querySelector('[data-mt-boton]');
      var precio = form.querySelector('[data-mt-precio]');
      var tachado = form.querySelector('[data-mt-tachado]');
      var textos = { ok: boton.dataset.textoOk, agotado: boton.dataset.textoAgotado };
      var formato = form.dataset.mtMoneda || '${{amount_no_decimals}}';
      function dinero(c) {
        var n = c / 100;
        var sin = Math.round(n).toLocaleString('en-US');
        var con = n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        return formato.replace(/\{\{\s*amount_no_decimals[^}]*\}\}/, sin).replace(/\{\{\s*amount[^}]*\}\}/, con);
      }
      function actualiza() {
        var elegidas = [];
        form.querySelectorAll('[data-mt-opcion]').forEach(function (f) {
          var c = f.querySelector('input:checked');
          elegidas.push(c ? c.value : null);
        });
        var v = variantes.find(function (x) { return x.options.every(function (o, i) { return o === elegidas[i]; }); });
        if (!v) return;
        input.value = v.id;
        if (precio) precio.textContent = dinero(v.price);
        var stickyPrecio = document.querySelector('[data-mt-sticky-precio]');
        if (stickyPrecio) stickyPrecio.textContent = dinero(v.price);
        if (tachado) { tachado.textContent = v.compare_at_price > v.price ? dinero(v.compare_at_price) : ''; }
        boton.disabled = !v.available;
        boton.querySelector('span').textContent = v.available ? textos.ok : textos.agotado;
        if (v.featured_media && v.featured_media.preview_image) {
          var mini = document.querySelector('.mt-galeria-mini[data-media-id="' + v.featured_media.id + '"]');
          if (mini) mini.click();
        }
      }
      form.querySelectorAll('[data-mt-opcion] input').forEach(function (i) { i.addEventListener('change', actualiza); });
    });
  }

  // Cuenta atrás hasta las 23:59 (hora de Nueva York) de la fecha AAAA-MM-DD; al terminar oculta el aviso
  function initCuentaAtras(raiz) {
    raiz.querySelectorAll('[data-mt-fin]').forEach(function (el) {
      if (el.dataset.mtInit) return;
      var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec((el.dataset.mtFin || '').trim());
      if (!m) return;
      el.dataset.mtInit = '1';
      var fin = Date.UTC(+m[1], +m[2] - 1, +m[3], 23, 59, 59) + 4 * 3600 * 1000;
      var caja = el.dataset.mtOcultarSeccion !== undefined ? (el.closest('[id^="shopify-section-"]') || el) : el;
      var d = el.querySelector('[data-mt-d]'), h = el.querySelector('[data-mt-h]'), mi = el.querySelector('[data-mt-m]'), s = el.querySelector('[data-mt-s]');
      function dos(n) { return (n < 10 ? '0' : '') + n; }
      function pinta() {
        var r = Math.floor((fin - Date.now()) / 1000);
        if (r <= 0) { caja.style.display = 'none'; clearInterval(t); return; }
        if (d) d.textContent = Math.floor(r / 86400);
        if (h) h.textContent = dos(Math.floor(r % 86400 / 3600));
        if (mi) mi.textContent = dos(Math.floor(r % 3600 / 60));
        if (s) s.textContent = dos(r % 60);
      }
      var t = setInterval(pinta, 1000);
      pinta();
    });
  }

  // Barra fija de compra en el móvil: visible mientras el botón principal no está en pantalla
  function initSticky(raiz) {
    raiz.querySelectorAll('[data-mt-sticky]').forEach(function (barra) {
      if (barra.dataset.mtInit) return;
      var principal = document.querySelector('[data-mt-boton]');
      if (!principal || !('IntersectionObserver' in window)) return;
      barra.dataset.mtInit = '1';
      new IntersectionObserver(function (entradas) {
        var ver = !entradas[0].isIntersecting;
        barra.classList.toggle('mt-visible', ver);
        barra.setAttribute('aria-hidden', ver ? 'false' : 'true');
        barra.querySelector('[data-mt-sticky-btn]').tabIndex = ver ? 0 : -1;
      }).observe(principal);
      barra.querySelector('[data-mt-sticky-btn]').addEventListener('click', function () {
        if (principal.disabled) { principal.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
        principal.click();
      });
    });
  }

  function initTodo(e) {
    var raiz = (e && e.target && e.target.querySelectorAll) ? e.target : document;
    initReveals(raiz); initHero(raiz); initHotspots(raiz); initFaq(raiz); initMagnetico(raiz); initGaleria(raiz); initVariantes(raiz); initCuentaAtras(raiz); initSticky(raiz);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initTodo); else initTodo();
  document.addEventListener('shopify:section:load', initTodo);
})();
